import { VaultsTotalStat } from './VaultsTotalStat';

export const VaultsPageHero = () => {
	return (
		<div className="flex w-full flex-col items-center justify-between gap-lg px-4 text-text-default sm:px-0">
			<div className="flex flex-col gap-y-md text-center text-text-default">
				<span className="typo-h3">Strategy Vaults</span>
				<span className="inline-block typo-b3 text-text-secondary">
					Maximize your yields with trading strategies from{' '}
					<br className="sm:hidden" /> leading teams across Solana.
				</span>
			</div>

			<VaultsTotalStat />
		</div>
	);
};
